import { useEffect, useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { checkCanShowExternalPurchaseLinks } from './checkCanShowExternalPurchaseLinks';

/**
 * Custom hook to check if external purchase links can be shown.
 *
 * Automatically triggers the geolocation check on first mount if not already done.
 *
 * @returns {Object} { canShowExternalPurchaseLinks: boolean, isChecked: boolean }
 */
export function useCanShowExternalPurchaseLinks() {
  const dispatch = useDispatch();

  const { canShowExternalPurchaseLinks, externalPurchaseLinksChecked } = useSelector(
    state => ({
      canShowExternalPurchaseLinks: state.device.canShowExternalPurchaseLinks,
      externalPurchaseLinksChecked: state.device.externalPurchaseLinksChecked
    }),
    shallowEqual
  );

  const checkLinks = useCallback(() => {
    dispatch(checkCanShowExternalPurchaseLinks());
  }, [dispatch]);

  useEffect(() => {
    if (!externalPurchaseLinksChecked) {
      checkLinks();
    }
  }, [externalPurchaseLinksChecked, checkLinks]);

  return {
    canShowExternalPurchaseLinks,
    isChecked: externalPurchaseLinksChecked
  };
}
